<template>
  <img src="/images/erkend-goed-doel.png" alt="Erkend Goed Doel" />
</template>
